import SelectDayDropdown from './template';
export default SelectDayDropdown;
